import React, { useEffect, useState } from 'react'
import Prices from '../../Components/Prices/Prices';

const PricesPage = () => {
    const [data, setData] = useState(null);

    const getData = () => {
    fetch('settings.json'
        , {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
        }
    ).then(function(response){
        return response.json();
    })
    .then(function(myJson) {
        console.log(myJson)
        setData(myJson.Components);
    });
    }
    useEffect(() => {
    getData()
    }, [])


    return (
        <div style={{paddingTop: "2rem"}}>
        {
            data && <Prices props={data.Prices}/>
        }            
        </div>
    )
}

export default PricesPage
